import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ui/toast';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import AuthCallback from './pages/AuthCallback';
import SetPassword from './pages/SetPassword';
import OrganizationSetup from './pages/OrganizationSetup';
import Dashboard from './pages/Dashboard';
import QueryResearch from './pages/QueryResearch';
import OptimiseContent from './pages/OptimiseContent';
import GeoWorkflow from './pages/GeoWorkflow';
import Websites from './pages/Websites';
import Keywords from './pages/Keywords';
import KeywordDetails from './pages/KeywordDetails';
import TopDomains from './pages/TopDomains';
import ReleaseNotes from './pages/ReleaseNotes';
import Settings from './pages/Settings';
import Team from './pages/Team';
import StyleDemo from './pages/StyleDemo';
import Opportunities from './pages/Opportunities';
import CompetitorIntelligence from './pages/CompetitorIntelligence';
import RedditInsights from './pages/RedditInsights';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import RequireAuth from './components/Auth/RequireAuth';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <div className="app">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
              path="/set-password"
              element={
                <RequireAuth>
                  <SetPassword />
                </RequireAuth>
              }
            />
            <Route
              path="/organization-setup"
              element={
                <RequireAuth>
                  <OrganizationSetup />
                </RequireAuth>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="research" element={<QueryResearch />} />
              <Route path="optimize" element={<OptimiseContent />} />
              <Route path="workflow" element={<GeoWorkflow />} />
              <Route path="opportunities" element={<Opportunities />} />
              <Route path="competitor-intelligence" element={<CompetitorIntelligence />} />
              <Route path="reddit-insights" element={<RedditInsights />} />
              <Route path="websites" element={<Websites />} />
              <Route path="keywords/:websiteId" element={<Keywords />} />
              <Route path="keyword/:keywordId" element={<KeywordDetails />} />
              <Route path="leading-domains" element={<TopDomains />} />
              <Route path="release-notes" element={<ReleaseNotes />} />
              <Route path="settings" element={<Settings />} />
              <Route path="team" element={<Team />} />
              <Route path="style-demo" element={<StyleDemo />} />
            </Route>
          </Routes>
          </div>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;